"use client"

import { MantineProvider } from "@mantine/core"
import { ModalsProvider } from "@mantine/modals"
import { Notifications } from "@mantine/notifications"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { cssVariablesResolver, theme } from "@/styles"
import { AuthProvider } from "./AuthProvider"
import { ConfigProvider } from "./ConfigProvider"
import { InitProvider } from "./InitProvider"
import { modalsRegistry } from "./modalsRegistry"
import { QueryProvider } from "./QueryProvider"
import { RadioPlayer, RadioPlayerProvider } from "./radio"
import { AppSpotlight, UserOnly } from "./utils"
import "@/utils/sentry"

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryProvider>
      <ReactQueryDevtools initialIsOpen={false} />

      <MantineProvider theme={theme} defaultColorScheme="auto" cssVariablesResolver={cssVariablesResolver}>
        <Notifications />

        <AuthProvider>
          <ConfigProvider>
            <InitProvider>
              <UserOnly>
                <AppSpotlight />
              </UserOnly>

              <ModalsProvider modals={modalsRegistry}>
                <RadioPlayerProvider>
                  <RadioPlayer />
                  {children}
                </RadioPlayerProvider>
              </ModalsProvider>
            </InitProvider>
          </ConfigProvider>
        </AuthProvider>
      </MantineProvider>
    </QueryProvider>
  )
}
